import { type ParsedLocation, redirect } from "@tanstack/react-router";
import type { UserContext } from "@/lib/interfaces/user-context";

export const validatePjAccess = ({
  location,
  user,
  billingId,
}: {
  location: ParsedLocation;
  user: UserContext;
  billingId: number;
}): void => {
  if (location.pathname.includes("settings/billing/details/")) {
    if (user.pj) {
      redirectToBoletoPage(String(billingId));
    }
  }
};

const redirectToBoletoPage = (billingId: string): void => {
  redirect({
    to: "/settings/billing/details/$billingId/boleto",
    throw: true,
    params: { billingId },
  });
};
